import { useAuthStore as c, selectAuthUserId as l, selectCurrentUser as m } from "@waitroom/auth";
import { useMemo as i } from "react";
import { createSelector as u } from "reselect";
import { isOnSameTeamWithPrimaryHost as C } from "../../../helpers/session.es.js";
import { getFeature as d } from "../../subscriptionPlan/helpers.es.js";
import { useSessionStore as S } from "../store.es.js";
import { selectSessionById as p, selectSessionState as r } from "./base.es.js";
const f = (s) => {
  var e;
  return (e = r(s).current) == null ? void 0 : e.id;
}, H = (s) => {
  var e;
  return (e = r(s).current) == null ? void 0 : e.recurrenceId;
}, P = (s) => {
  var e;
  return (e = r(s).current) == null ? void 0 : e.latestRecurrence;
}, t = (s) => {
  const { id: e, recurrenceId: n } = s.current || {};
  return e ? p(s, e, n || "") : void 0;
}, D = (s) => {
  var e;
  return (e = t(s)) == null ? void 0 : e.sessionID;
}, E = (s) => {
  var e;
  return (e = t(s)) == null ? void 0 : e.sessionRecurrenceID;
}, O = (s) => {
  var e;
  return (e = t(s)) == null ? void 0 : e.sessionTitle;
}, h = (s) => {
  var e;
  return (e = t(s)) == null ? void 0 : e.about;
}, v = (s) => {
  var e;
  return (e = t(s)) == null ? void 0 : e.cover;
}, W = (s) => {
  const e = t(s);
  return e ? e.branchURL || e.publicURL : void 0;
}, k = (s) => {
  var e;
  return (e = t(s)) == null ? void 0 : e.subscriptionPlan;
}, z = (s) => {
  var e;
  return (e = t(s)) == null ? void 0 : e.accessStatus;
}, B = (s) => {
  var e;
  return (e = t(s)) == null ? void 0 : e.meetingType;
}, L = (s) => {
  var e;
  return (e = t(s)) == null ? void 0 : e.sessionSettings;
}, M = (s) => {
  var e, n;
  return (((n = (e = t(s)) == null ? void 0 : e.sessionSettings) == null ? void 0 : n.recurring) || 0) > 0;
}, V = (s) => {
  var e, n;
  return !!((n = (e = t(s)) == null ? void 0 : e.sessionSettings) != null && n.summaAI);
}, q = (s) => {
  var e, n;
  return !!((n = (e = t(s)) == null ? void 0 : e.sessionSettings) != null && n.enableRecording);
}, x = (s) => {
  var e, n;
  return !!((n = (e = t(s)) == null ? void 0 : e.sessionSettings) != null && n.postSessionSummaries);
}, F = (s) => {
  var e, n;
  return !!((n = (e = t(s)) == null ? void 0 : e.sessionSettings) != null && n.isRecall);
}, Q = (s) => {
  var e, n;
  return !!((n = (e = t(s)) == null ? void 0 : e.sessionSettings) != null && n.screenSharingDisabled);
}, j = (s) => {
  var e;
  return (e = t(s)) == null ? void 0 : e.startTimestamp;
}, w = (s) => {
  var e;
  return (e = t(s)) == null ? void 0 : e.endTimestamp;
}, G = (s) => {
  var e;
  return (e = t(s)) == null ? void 0 : e.startedAt;
}, J = (s) => {
  var e;
  return (e = t(s)) == null ? void 0 : e.endedAt;
}, K = (s) => {
  var e, n;
  return (n = d((e = t(s)) == null ? void 0 : e.subscriptionPlan, "stream")) == null ? void 0 : n.quality;
}, N = (s) => {
  var e;
  return (e = t(s)) == null ? void 0 : e.sessionState;
}, X = (s) => {
  var e;
  return (e = t(s)) == null ? void 0 : e.dataVisibility;
}, o = (s) => {
  var e;
  return (e = t(s)) == null ? void 0 : e.hosts;
}, Y = (s) => u(
  o,
  (e) => !!s && (e == null ? void 0 : e.some((n) => n.id === s))
), a = (s) => {
  var e;
  return (e = t(s)) == null ? void 0 : e.primaryHostUserID;
}, g = (s) => {
  var e;
  return (e = t(s)) == null ? void 0 : e.primaryHost;
}, Z = (s) => (e) => !!s && a(e) === s, _ = u(
  o,
  a,
  (s, e) => s == null ? void 0 : s.find((n) => n.id === e)
), $ = (s) => {
  var e;
  return ((e = o(s)) == null ? void 0 : e.length) || 0;
}, ee = (s) => (e) => C(g(e), s), se = (s) => {
  var e;
  return (e = t(s)) == null ? void 0 : e.stateUpdatedAt;
}, te = (s) => r(s).current.consentToBroadcast, ne = (s) => {
  const e = c(l);
  return S(i(() => s(e), [s, e]));
}, re = (s) => {
  const e = c(m);
  return S(i(() => s(e), [s, e]));
};
export {
  Y as makeSelectIsCurrentSessionHost,
  Z as makeSelectIsCurrentSessionOrganizer,
  ee as makeSelectIsOnSameTeamWithPrimaryHost,
  t as selectCurrentSession,
  V as selectCurrentSessionAIEnabled,
  x as selectCurrentSessionAISummaryEnabled,
  h as selectCurrentSessionAbout,
  z as selectCurrentSessionAccessStatus,
  v as selectCurrentSessionCover,
  X as selectCurrentSessionDataVisibility,
  w as selectCurrentSessionEndTimestamps,
  J as selectCurrentSessionEndedAt,
  o as selectCurrentSessionHosts,
  $ as selectCurrentSessionHostsCount,
  D as selectCurrentSessionId,
  M as selectCurrentSessionIsRecurring,
  P as selectCurrentSessionLatestRecurrence,
  B as selectCurrentSessionMeetingType,
  _ as selectCurrentSessionOrganizer,
  a as selectCurrentSessionOrganizerId,
  g as selectCurrentSessionPrimaryHost,
  F as selectCurrentSessionRecallEnabled,
  q as selectCurrentSessionRecordingEnabled,
  E as selectCurrentSessionRecurrenceId,
  Q as selectCurrentSessionScreenSharingDisabled,
  L as selectCurrentSessionSettings,
  W as selectCurrentSessionShareUrl,
  j as selectCurrentSessionStartTimestamps,
  G as selectCurrentSessionStartedAt,
  f as selectCurrentSessionStateId,
  H as selectCurrentSessionStateRecurrenceId,
  se as selectCurrentSessionStateUpdates,
  N as selectCurrentSessionStatus,
  k as selectCurrentSessionSubscriptionPlan,
  K as selectCurrentSessionSubscriptionPlanStreamQuality,
  O as selectCurrentSessionTitle,
  te as selectSessionConsentToBroadcast,
  re as useSessionSelectorWithCurrentUser,
  ne as useSessionSelectorWithCurrentUserId
};
